import styled from 'styled-components';

const SimpleMenuContainer = styled.div`
  .simple-nav-item {
    align-items: center;
    display: flex;
    flex: 1;
    padding: 10px;
    margin-bottom: 5px;
    width: 100%;

    h6 {
      margin: 0;
      font-weight: 500;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  img {
    width: 28px;
    margin-right: 15px;
    image-rendering: unset;
  }

  a {
    color: var(--black);
    margin-top: 3px;
  }
  > .MuiGrid2-root {
    margin: 0;
    > .simple-nav-col {
      width: auto;
      &.right {
        padding-right: 20px;
      }
      &.left {
        padding-left: 20px;
      }
    }
  }
  .simple-nav-ctas {
    margin: 20px 0 -10px 0;
  }
`;

export { SimpleMenuContainer };
